const ENDimensions = {
	"Alterar dimensão": "Change dimension",
	"Deseja realmente excluir a dimensão": "Do you really want to delete the dimension",
	"Dimensão adicionada com sucesso": "Dimension successfully added",
	"Dimensão alterada com sucesso": "Dimension successfully changed",
	"Dimensão excluída com sucesso": "Dimension successfully deleted",
	"Dimensões reordenadas com sucesso": "Dimension successfully reorder",
	"Erro ao adicionar dimensão": "Error adding dimension",
	"Erro ao alterar dimensão": "Error changing dimension",
	"Erro ao excluir dimensão": "Error deleting dimension",
	"Erro ao listar dimensões": "Error listing dimensions",
	"Erro ao reordenar dimensões": "Error reorder dimensions",
	"Exclusão da dimensão": "Delete dimension",
	"Inserir dimensão": "Insert dimension",
	"Nova dimensão": "New dimension",
	"Ordenar dimensões": "Reorder dimensions"
};

export default ENDimensions;

